import { useEffect, useState } from 'react'

import { useRTDContext } from '../Overview/context'

const RTD_DEFAULT_PAGE_SIZE = 10

const getChunks = (data, pageSize) =>
  data.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / pageSize)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }

    resultArray[chunkIndex].push(item)

    return resultArray
  }, [])

export const usePaginatedTableData = (
  tableData,
  sorting: {
    sortKey: number | undefined
    sortDirection: 'asc' | 'desc'
    nestedFilter?: Record<string, boolean>
  },
  pageSize?: number
) => {
  const PAGE_SIZE = pageSize ?? RTD_DEFAULT_PAGE_SIZE
  const pageChunks = getChunks(tableData, PAGE_SIZE)
  const [pageIndex, setPageIndex] = useState(0)

  const { filteredAgents: agentsToFilter } = useRTDContext()

  const totalPages = Math.ceil(tableData.length / PAGE_SIZE)

  const onChangePage = (direction) => {
    const newPage = pageIndex + direction
    setPageIndex(newPage)
  }

  const { sortKey, sortDirection, nestedFilter } = sorting

  useEffect(() => {
    setPageIndex(0)
  }, [sortKey, sortDirection, nestedFilter, agentsToFilter])

  return {
    totalPages,
    onChangePage,
    paginatedData: pageChunks[pageIndex] ?? [],
    pageIndex,
    PAGE_SIZE,
  }
}
